// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1O97i","modalForm":"UpgradeEpcsModal_modalForm__L2ljM","modalFooter":"UpgradeEpcsModal_modalFooter__H0MQU"};